module.exports = __webpack_public_path__ + "img/21.b1cb0340.png";